<style>
@import '../../../custom/css/lista-dicas.css';

/* #representantes .limit-table::-webkit-scrollbar:vertical {
  display: none;
} */
</style>

<template>
  <div id="representantes">
    <h1 class="title text-uppercase font-weight-bold">Lista de Afiliados</h1>
    <hr class="linha-amarela" />
    <table class="table">
      <thead class="letter-orange">
        <tr>
          <th></th>
          <th>Nome</th>
          <th>E-mail</th>
          <th>Avaliado</th>
          <th v-if="hasWritePermission()">Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(affiliate, index) in getAffiliates" :key="index">
          <td class="font-weight-bold fs-20">
            {{ index + 1 }}
          </td>
          <td>
            {{ affiliate.nome || 'Sem nome' }}
          </td>
          <td>
            {{ affiliate.email || 'Sem e-mail' }}
          </td>
          <td>
            <i
              class="fas fa-times fs-20 c-red"
              v-if="affiliate.status === AffiliateState.NOT_EVALUATED"
            ></i>
            <i class="fas fa-check fs-20 c-green" v-else></i>
          </td>
          <td v-if="hasWritePermission()">
            <b-btn
              v-if="
                affiliate.status === AffiliateState.APPROVED ||
                affiliate.status === AffiliateState.REPROVED
              "
              class="btn-warning mr-1"
              @click="seeAffiliate(affiliate.id)"
              title="Ver"
            >
              <i class="fas fa-eye"></i>
            </b-btn>
            <b-btn
              v-if="affiliate.status === AffiliateState.APPROVED"
              class="btn-info mr-1"
              @click="editAffiliate(affiliate.id)"
              title="Editar"
            >
              <i class="fas fa-edit"></i>
            </b-btn>
            <b-btn
              v-if="affiliate.status === AffiliateState.NOT_EVALUATED"
              class="btn btn-success mr-1"
              @click="seeAffiliate(affiliate.id)"
              title="Avaliar"
            >
              <i class="fas fa-tasks"></i>
            </b-btn>
            <b-btn
              v-if="
                affiliate.status === AffiliateState.APPROVED ||
                affiliate.status === AffiliateState.REPROVED
              "
              class="btn-danger"
              @click="deleteAffiliate(affiliate.usuario_id)"
              title="Excluir"
            >
              <i class="fas fa-trash-alt"></i>
            </b-btn>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import makeToast from '../../../mixins/makeToast';
import AffiliateState from '../../../enums/Affiliate/AffiliateState';

export default {
  name: 'Affiliates',
  mixins: [makeToast],
  computed: {
    ...mapGetters('affiliate', ['getAffiliates']),
    ...mapState(['token', 'dadosUsuario']),
  },
  data() {
    return {
      AffiliateState,
    };
  },
  created() {
    this.getAllAffiliates();
  },
  methods: {
    ...mapActions('affiliate', ['getAll']),
    getAllAffiliates() {
      this.$store.dispatch('startLoader');
      this.getAll().finally(() => this.$store.dispatch('endLoader'));
    },
    editAffiliate(id) {
      this.$router.push({
        name: 'administrador-editar-afiliado',
        params: { id },
      });
    },
    seeAffiliate(id) {
      this.$router.push({
        name: 'administrador-ver-afiliado',
        params: { id },
      });
    },
    deleteAffiliate(id) {
      if (window.confirm('Deseja deletar realmente esse afiliado?')) {
        this.$store.dispatch('startLoader');
        this.$store
          .dispatch('deleteUsuario', id)
          .then(() => {
            this.makeToast('Successo!', 'Deletado com sucesso');
            this.getAllAffiliates();
          })
          .catch(() => {
            this.makeToast(
              'Oopss!',
              'Houve um problema para deletar, tente novamente em 5 minutos!',
              'danger'
            );
          })
          .finally(() => {
            this.$store.dispatch('endLoader');
          });
      }
    },
    hasWritePermission() {
      return this.dadosUsuario.permitido_escrita == 1;
    },
  },
};
</script>
